import { render, staticRenderFns } from "./Parent.vue?vue&type=template&id=56915c65&scoped=true&lang=html&"
import script from "./Parent.vue?vue&type=script&lang=js&"
export * from "./Parent.vue?vue&type=script&lang=js&"
import style0 from "./Parent.vue?vue&type=style&index=0&id=56915c65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56915c65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VLayout,VSnackbar,VTextField})
